import Vue from 'vue';
import Component from 'vue-class-component';
import {AXIOS} from "@/lib/http-common";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {Prop} from "vue-property-decorator";
import Property from "@/components/properties/model/Property";

@Component({})
export default class ConfigurableSettingView extends Vue {
  public loadingConfigurableSetting: boolean = false;
  public updatingConfigurableSetting: boolean = false;

  @Prop({default: [], required: true})
  public selectEnumValues!: string[];
  @Prop({required: true})
  public restEndPoint!: string;
  @Prop({required: true})
  public propKey!: string;
  @Prop({required: true})
  public successMessageCode!: string;
  @Prop({required: true})
  public configurableSettingName!: string;
  @Prop({required: true})
  public configurableSettingIcon!: string;
  @Prop({required: false})
  public tooltipInformation!: string;

  public configurableSetting: string = '';
  public databaseConfigurableSetting: string = '';

  public mounted() {
    this.getUnitsFromBackend();
  }

  public getUnitsFromBackend() {
    this.loadingConfigurableSetting = true;
    AXIOS.get(`${this.restEndPoint}/${this.propKey}`)
      .then((message) => {
        this.configurableSetting = message.data.propValue;
        this.databaseConfigurableSetting = this.configurableSetting;
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.loadingConfigurableSetting = false;
      });
  }

  public updateConfigurableSetting() {
    this.updatingConfigurableSetting = true;
    const propertyDto: Property = {propKey: this.propKey, propValue: this.configurableSetting};
    AXIOS.put(this.restEndPoint, propertyDto)
      .then(() => {
        this.databaseConfigurableSetting = this.configurableSetting;
        UserActionResultSender.showSuccessFeedback(this.successMessageCode);
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.updatingConfigurableSetting = false;
      });
  }
}
